export enum ReloadDetailKinds {
  Everytime = 1,
  ExceptFreeInput = 2,
}
